export default __webpack_public_path__ + "static/media/13.67715415.svg";